module.exports = __webpack_public_path__ + "img/18.6b99ee8b.jpg";